export default "__VITE_ASSET__CInkThHD__"